import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.function.name.js";
import { createElementVNode as _createElementVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/subpage/page-title.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-083b09aa"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "sub-page"
};
var _hoisted_2 = {
  "class": "header"
};
var _hoisted_3 = {
  "class": "input-box"
};
var _hoisted_4 = {
  "class": "nav"
};
var _hoisted_5 = {
  "class": "bread"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    "class": "index",
    style: {
      "margin": "0 7px"
    }
  }, ">", -1);
});
var _hoisted_7 = {
  key: 1,
  "class": "index",
  style: {
    "margin": "0 7px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_link = _resolveComponent("router-link");
  var _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: _imports_0,
    alt: "GLP-1百科",
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.$router.push('/index');
    })
  }), _createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("input", {
    type: "text",
    onKeyup: _cache[1] || (_cache[1] = _withKeys(function () {
      return $options.handleSearch && $options.handleSearch.apply($options, arguments);
    }, ["enter"])),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.searchText = $event;
    }),
    placeholder: "请输入你想查找的关键词例如：司美格鲁肽"
  }, null, 544), [[_vModelText, $data.searchText]]), _createElementVNode("span", {
    onClick: _cache[3] || (_cache[3] = function () {
      return $options.handleSearch && $options.handleSearch.apply($options, arguments);
    })
  }, "搜索")])]), _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.routeList, function (item, index) {
    return _openBlock(), _createBlock(_component_router_link, {
      "class": _normalizeClass(["route", {
        'route-active': _ctx.$route.path.indexOf(item.path) != -1
      }]),
      key: index,
      to: item.path
    }, {
      "default": _withCtx(function () {
        return [_createTextVNode(_toDisplayString(item.name), 1)];
      }),
      _: 2
    }, 1032, ["class", "to"]);
  }), 128)), _createTextVNode("  ")]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_router_link, {
    to: "/index",
    "class": "route index"
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode("首页")];
    }),
    _: 1
  }), _hoisted_6, _ctx.$route.path == '/article' ? (_openBlock(), _createBlock(_component_router_link, {
    key: 0,
    to: "/clinicalGuideline",
    "class": "route index"
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode("临床指南")];
    }),
    _: 1
  })) : _createCommentVNode("", true), _ctx.$route.path == '/article' ? (_openBlock(), _createElementBlock("span", _hoisted_7, ">")) : _createCommentVNode("", true), _createVNode(_component_router_link, {
    "class": "route current",
    to: _ctx.$route.path
  }, {
    "default": _withCtx(function () {
      return [_createTextVNode(_toDisplayString(_ctx.$route.meta.title), 1)];
    }),
    _: 1
  }, 8, ["to"])]), _createVNode(_component_router_view, {
    "class": "sub-container"
  })]);
}